const KEY = "facturize_license_status";
const TTL_MS = 5 * 60 * 1000;

export const getCachedLicenseStatus = () => {
  try {
    const cached = JSON.parse(sessionStorage.getItem(KEY) || "null");
    if (!cached?.valid || !cached.checkedAt) return null;
    if (Date.now() - cached.checkedAt > TTL_MS) return null;

    if (cached.expiresAt) {
      const expiresAt = new Date(`${cached.expiresAt}T23:59:59`);
      if (Number.isFinite(expiresAt.getTime()) && expiresAt < new Date()) return null;
    }

    return cached;
  } catch (error) {
    return null;
  }
};

export const setCachedLicenseStatus = (payload = {}) => {
  sessionStorage.setItem(KEY, JSON.stringify({
    valid: true,
    checkedAt: Date.now(),
    expiresAt: payload.license?.expiresAt || payload.license?.expires_at || payload.expiresAt || null,
  }));
};

export const clearCachedLicenseStatus = () => {
  sessionStorage.removeItem(KEY);
};
